import { useState } from 'react'

/**
 * The scenario as a link, to copy.
 *
 * Read-only and shown in full: the URL *is* the scenario, so seeing it is how
 * a reader learns that the thing they just built is shareable. Nothing is
 * encoded, which is why it can be read at all.
 */
export function ScenarioLink({ query }: { query: string }) {
  const [copied, setCopied] = useState(false)
  const href = `${location.origin}/config${query ? `?${query}` : ''}`

  return (
    <div className="scenario-link">
      <label className="field">
        <span>Link to this scenario</span>
        <input type="text" readOnly value={href} onFocus={(event) => event.target.select()} />
      </label>
      <button
        type="button"
        onClick={() => {
          void navigator.clipboard
            ?.writeText(href)
            .then(() => {
              setCopied(true)
              setTimeout(() => setCopied(false), 1600)
            })
            // Clipboard access can be refused; the field is still selectable.
            .catch(() => setCopied(false))
        }}
      >
        {copied ? 'Copied' : 'Copy'}
      </button>
    </div>
  )
}
